export default __webpack_public_path__ + "static/media/indoor-2.91337a06.png";